import type { ComponentProps, FC } from 'react';
import { Button } from '@george-labs.com/design-system';

import { t } from '@luna/i18n';
import { useActiveCustomizationFeature } from '@shared/products-core';
import { ProductColorChangeDropdown } from '@retail/products-customisation';
import { CustomizationService } from '@api-client/products';

import { useCustomizationSuccessHandler } from './hooks/useCustomizationSuccessHandler';
import { useActivePAPIProduct } from '../../../ActivePAPIProductContext';

export const ColorChange: FC = () => {
    const { activateColorChangeCustomization } = useActiveCustomizationFeature();
    const { id, type } = useActivePAPIProduct();
    const handleSuccessfulCustomization = useCustomizationSuccessHandler();

    const handleColorSave: ComponentProps<
        typeof ProductColorChangeDropdown
    >['onColorSave'] = async (color) => {
        CustomizationService.putPublicProductsCustomizationColor({
            id,
            requestBody: {
                color: color.toUpperCase(),
            } as unknown as Parameters<
                typeof CustomizationService.putPublicProductsCustomizationColor
            >[0]['requestBody'],
        }).then((customization) => {
            handleSuccessfulCustomization(customization);
        });
    };

    return (
        <ProductColorChangeDropdown
            data-cy="products-color-change-dropdown"
            toggle={
                <Button
                    icon={Button.ICON.PALETTE}
                    size={Button.SIZE.SMALL}
                    onClick={activateColorChangeCustomization}
                    data-cy="product-edit-color-button"
                    className="g-inverted"
                >
                    {t('mainOverview.action.changeColor_a11y')}
                </Button>
            }
            actionButtonDataCy="product-edit-color-save-button"
            onColorSave={handleColorSave}
            colorChangeContext="details"
            trigger="productDetail"
            accountType={type}
        />
    );
};
